import script from "./Sprachtechnik-Statistics-Reports.vue?vue&type=script&setup=true&lang=js"
export * from "./Sprachtechnik-Statistics-Reports.vue?vue&type=script&setup=true&lang=js"

import "./Sprachtechnik-Statistics-Reports.vue?vue&type=style&index=0&id=33b85f09&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b85f09"]])

export default __exports__